var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"va-item-section",class:{
    'va-item-section--main': !_vm.side && !_vm.avatar,
    'va-item-section--side': _vm.side,
    'va-item-section--avatar': _vm.avatar
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }